<template>
    <div class="not-found">
      <div class="content">
        <h1>404</h1>
        <h2>Página no encontrada</h2>
        <p>La página que está buscando no existe o ha sido movida.</p>
        <router-link to="/" class="btn btn-primary btn-round">
          Volver al inicio
        </router-link>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NotFound'
  };
  </script>
  
  <style scoped>
  .not-found {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    background-color: #f4f3ef;
  }
  .content {
    padding: 2rem;
  }
  h1 {
    font-size: 6rem;
    margin-bottom: 0;
    color: #ef8157;
  }
  h2 {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 2rem;
  }
  </style>